<script>
import {onMount} from 'svelte';
import {ComplexArray} from 'jsfft';
import {getClef} from './path';

export let styleWidth = 120;

ComplexArray.prototype.phase = function() {
	const args = new this.ArrayType(this.length);

	this.forEach((value, i) => {
		let x = value.real;
		let y = value.imag;
		let arg = Math.atan(y / x);

		if      (x > 0)           { args[i] = arg; }
		else if (x < 0 && y >= 0) { args[i] = arg + Math.PI; }
		else if (x < 0 && y < 0)  { args[i] = arg - Math.PI; }
		else if (x == 0 && y > 0) { args[i] = Math.PI/2; }
		else if (x == 0 && y < 0) { args[i] = -Math.PI/2; }
		else                      { args[i] = NaN; }
	})

	return args;
}

let canvas;
let ctx;
let requestToken;
let trace = []
let vectors;

let width = 120;
let height = 360;
let nCoeff = 1;
const Pi2 = 2 * Math.PI;
const speed = .02;

// TAO: https://youtu.be/5vJ7rfoR3ng?t=72
// Pressure (line width), time, x, y

function drawLines(ctx, vertices) {
  for (let i = 0; i < vertices.length - 1; i += 1) {
    ctx.beginPath();
    let p0 = vertices[i];
    let p1 = vertices[i + 1];
    ctx.moveTo(p0[0], p0[1]);
    ctx.lineTo(p1[0], p1[1]);
    ctx.lineWidth = 1 + (vertices.length - i) * .01;
    ctx.stroke();
  }
}

function animate() {
  requestToken = requestAnimationFrame(animate)

  const t = Math.floor(performance.now() * speed);

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = ctx.strokeStyle = 'white';
  ctx.lineWidth = 1;

  const lines = new Array(nCoeff - 1);
  let x = 0, y = 0;
  vectors.slice(0, nCoeff).forEach((v, i) => {
    const angle = v.speed * t + v.phase;
    x += Math.cos(angle) * v.radius;
    y += Math.sin(angle) * v.radius;
    lines[i] = [x, y]
  });

  drawLines(ctx, lines)

  const tip = lines[lines.length - 1];
  trace.push(tip)

  ctx.lineWidth = 2;
  for (let i = 0; i < trace.length - 1; i += 1) {
    let alpha = i/trace.length;
    ctx.strokeStyle = 'rgba(212, 232, 255, ' + alpha + ')';
    let p0 = trace[i];
    let p1 = trace[i + 1];
    ctx.beginPath();
    // ctx.lineWidth = i * .01;
    ctx.moveTo(p0[0], p0[1]);
    ctx.lineTo(p1[0], p1[1]);
    ctx.stroke();
  }

  if (trace.length > vectors.length * 6) {
    trace.shift();
  }
}

onMount(() => {
  const scale = 2;
  const path = getClef(width, height).map(([x, y]) => [scale * x, scale * y]);

  // Compute FFT
  const coeff = new ComplexArray(path.length).map((v, i) => {
    v.real = path[i][0];
    v.imag = path[i][1];
  });
  coeff.FFT();

  // Compute circles
  const mags = coeff.magnitude();
	const phases = coeff.phase();

  const count = coeff.length;
	const coeffPolar = new Array(count);
  for (let i = 0; i < count; i++) {
		coeffPolar[i] = {mag: mags[i], phase: phases[i], freq: i};
	}

	coeffPolar.sort((a, b) => b.mag - a.mag);

  nCoeff = Math.min(coeff.length, 500);

	// update circles with fourier series coefficients
	vectors = coeffPolar.map(polar => ({
    radius: polar.mag / Math.sqrt(count),
    speed: polar.freq * Pi2 / count,
    phase: polar.phase
  }))

  ctx = canvas.getContext("2d");
  animate()
  return () => cancelAnimationFrame(requestToken);
})

</script>

<canvas bind:this={canvas} {width} {height} style="width:{styleWidth}px"/>